import { makeAutoObservable } from 'mobx';
import {api} from 'shared/core';
import {endpoints} from 'main/tools';
import {redirect} from 'shared/tools';

class DemoBannerState {
  showModal = false;

  constructor() {
    makeAutoObservable(this);
  }

  closeDemoBannerModal() {
    this.showModal = false;
  }

  openDemoBannerModal() {
    this.showModal = true;
  }

  async beginConfiguration() {
    await api.patch(endpoints.COMPANY_BEGIN_CONFIGURATION);

    return redirect('/account_setup_in_progress');
  }
}

export default DemoBannerState;
